import { formatObject } from "./asset";

const getMobileLocationName = rackLocation => {
  const mobileLocation =
    rackLocation?.mobile_warehouse_location || rackLocation?.mobileWarehouseLocation;

  return mobileLocation?.location_name || mobileLocation?.locationName || null;
};

export const getShipmentItemMobileLocationRackLocations = shipmentItem => {
  const shipmentItemRackLocations = Array.isArray(shipmentItem?.rackLocations)
    ? shipmentItem.rackLocations
    : [];

  if (shipmentItemRackLocations.some(rackLocation => Boolean(getMobileLocationName(rackLocation)))) {
    return shipmentItemRackLocations;
  }

  return Array.isArray(shipmentItem?.asset?.rackLocations) ? shipmentItem.asset.rackLocations : [];
};

export const shipmentItemHasMobileLocationLabels = shipmentItem =>
  getShipmentItemMobileLocationRackLocations(shipmentItem).some(rackLocation =>
    Boolean(getMobileLocationName(rackLocation))
  );

export const shipmentHasMobileLocationLabels = shipment =>
  Array.isArray(shipment?.shipmentItems) &&
  shipment.shipmentItems.some(shipmentItemHasMobileLocationLabels);

export const getShipmentDisplayFields = (value) => {
  return [
    ...formatObject(value.shipments_info || {}),
    ...formatObject(value.shipment_items_info || {}),
    ...formatObject(value.osd_info || {}),

    // Add asset field categories if report sub type requires it
    ...formatObject(value.include || {}),
    ...formatObject(value.descriptive_info || {}),
    ...formatObject(value.warehouse_info || {}),
    ...formatObject(value.other_info || {}),
    ...formatObject(value.configurable_custom_fields || {}),
  ];
}; 